import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { propArrayShape, propFunc, propNumber, propShape, propStr, } from '../../../helpers/custom-prop-types';
import { getFormValue } from '../../../helpers/form';
import CategoryMiddleSingleFieldsAndLabel from './CategoryMiddleSingleFieldsAndLabel';
const CategoryMiddleFieldsAndLabel = (props) => {
    const { categoryLargeClasses, categoryMiddleClasses, label, largeKeyInMiddle, maximum, name, otherMiddleClassName, otherName, thisForm, wrapMiddleClassName, wrapOnChange, } = props;
    const formValues = getFormValue(thisForm, name) || [];
    const transforms = Object.keys(formValues).filter((key) => formValues[key]);
    return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsxs("h3", { children: [label, maximum ? _jsx("small", { children: `最大${maximum}つまで選択可能` }) : undefined] }), _jsx("div", Object.assign({ className: 'multiple-checkbox special-industry' }, { children: _jsx("dl", { children: categoryLargeClasses.map((large) => (_jsxs(Fragment, { children: [_jsx("dt", { children: large.name }), _jsx("dd", { children: categoryMiddleClasses
                                    .filter((row) => row[largeKeyInMiddle] === large.id)
                                    .map((middle) => {
                                    const { isOther } = middle;
                                    const middleId = middle.id;
                                    const middleIdStr = middle.id.toString();
                                    const isEtcCheck = !!(isOther && transforms.includes(middleIdStr));
                                    return (_jsx(CategoryMiddleSingleFieldsAndLabel, { disabled: !!(maximum &&
                                            transforms.length >= maximum &&
                                            !transforms.includes(middleIdStr)), isEtcCheck: isEtcCheck, middleId: middleId, middleIsOther: !!isOther, middleName: middle.name, name: `${name}[${middle.id}]`, otherMiddleClassName: otherMiddleClassName, otherName: `${otherName}[${middle.id}]`, wrapMiddleClassName: wrapMiddleClassName, wrapOnChange: wrapOnChange }, middle.id));
                                }) })] }, large.id))) }) }))] })));
};
CategoryMiddleFieldsAndLabel.propTypes = {
    categoryLargeClasses: propArrayShape().isRequired,
    categoryMiddleClasses: propArrayShape().isRequired,
    label: propStr().isRequired,
    largeKeyInMiddle: propStr().isRequired,
    maximum: propNumber(),
    name: propStr().isRequired,
    otherMiddleClassName: propStr(),
    otherName: propStr(),
    thisForm: propShape().isRequired,
    wrapMiddleClassName: propStr(),
    wrapOnChange: propFunc(),
};
CategoryMiddleFieldsAndLabel.defaultProps = {
    maximum: 0,
    otherMiddleClassName: '',
    otherName: '',
    wrapMiddleClassName: '',
    wrapOnChange: undefined,
};
export default CategoryMiddleFieldsAndLabel;
